<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    var vm = this;

    return {
      top5Colors: ["#727cf5", "#0acf97", "#fa5c7c", "#ffbc00", "#39afd1"],
      performanceColors: [
        "#ff6e61",
        "#ffab8a",
        "#ffd1b3",
        "#d4b7e1",
        "#6a4c94",
        "#6f42c1"
      ],
      store: 0,
      top_store: {
        table: [],
        chart: {
          series: [],
          chartOptions: {
            labels: [],
            chart: {
              type: "donut",
              height: 224,
            },
            plotOptions: {
              pie: {
                size: 100,
                offsetX: 0,
                offsetY: 0,
                donut: {
                  size: "70%",
                  labels: {
                    show: true,
                    name: {
                      show: false,
                    },
                    value: {
                      show: false,
                    },
                    total: {
                      show: false,
                    },
                  },
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            legend: {
              show: false,
            },
            stroke: {
              lineCap: "round",
              width: 2,
            },
            colors: [],
          },
        }
      },
      monthly: {
        chart: {
          series: [],
          chartOptions: {
            chart: {
              type: "bar",
              height: 600,
              stacked: true,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },],
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 5,
              },
            },
            xaxis: {
              categories: [],
            },
            legend: {
              position: "bottom",
              offsetX: 0,
            },
            fill: {
              opacity: 1,
            },
            colors: vm.performanceColors,
          },
        }
      }
    };
  },
  mounted() {
    var vm = this;

    vm.load();
  },
  methods: {
    load() {
      var vm = this;

      vm.fetchStore();
      vm.fetchTopStore();
      vm.fetchMonthly();
    },
    fetchStore: async function () {
      var vm = this;
      this.$loading.on('dashboard_store');

      try {
        const resp = await this.$api.Dashboard.store()

        const data = resp.data.data;

        vm.store = data
      } catch (err) {
        // console.log(err);
      }
      this.$loading.off('dashboard_store');
    },
    fetchTopStore: async function () {
      var vm = this;
      this.$loading.on('dashboard_top_store');

      try {
        const resp = await this.$api.Dashboard.topStore()

        const data = resp.data.data;

        var colors = vm.top5Colors;
        var table = vm.$_.map(data, function (x) {
          x.color = colors.shift();

          return x;
        })

        vm.top_store.table = table;
        vm.top_store.chart = {
          ...vm.top_store.chart,
          series: vm.$_.map(table, 'total'),
          chartOptions: {
            ...vm.top_store.chart.chartOptions,
            labels: vm.$_.map(table, 'name'),
            colors: vm.$_.map(table, 'color'),
          }
        };
      } catch (err) {
        // console.log(err);
      }
      this.$loading.off('dashboard_top_store');
    },
    fetchMonthly: async function () {
      var vm = this;
      this.$loading.on('dashboard_performance');

      try {
        const resp = await this.$api.Dashboard.monthly();

        const data = resp.data.data;

        const storeNames = vm.$_.uniq(
          vm.$_.flatten(
            vm.$_.map(data, function (item) {
              return vm.$_.map(item.store, 'name');
            })
          )
        );

        // categories xaxis
        const categories = vm.$_.map(data, function (item) {
          return item.month + '/' + item.year;
        });

        // build series
        const series = vm.$_.map(storeNames, function (storeName) {
          return {
            name: storeName,
            data: vm.$_.map(data, function (monthItem) {
              const found = vm.$_.findWhere(monthItem.store, {
                name: storeName,
              });

              return found ? found.total : 0;
            }),
          };
        });

        vm.monthly.chart = {
          ...vm.monthly.chart,

          series: series,

          chartOptions: {
            ...vm.monthly.chart.chartOptions,
            colors: vm.performanceColors,
            xaxis: {
              ...vm.monthly.chart.chartOptions.xaxis,
              categories: categories,
            },
          },
        };
      } catch (err) {
        // console.log(err);
      }
      this.$loading.off('dashboard_performance');
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('dashboard.title.list')" :pageTitle="$t('menu.sub_header.dashboard')" />

    <BRow>
      <BCol lg="3">
        <BRow>
          <BCol lg="12">
            <BCard no-body>
              <BCardBody>
                <div class="d-flex align-items-center">
                  <div class="avatar-sm flex-shrink-0">
                    <span class="avatar-title bg-light text-primary rounded-circle shadow fs-3">
                      <i class="mdi mdi-storefront-outline align-middle"></i>
                    </span>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <p class="text-uppercase fw-semibold fs-12 text-muted mb-1">
                      {{ $t('dashboard.label.store') }}
                    </p>
                    <h4 class="mb-0">
                      <span class="counter-value">
                        <skeleton :loading="$loading.get('dashboard_store')" :schema="['col-1']">
                          <count-to :startVal='0' :endVal='store' :duration='3000'></count-to>
                        </skeleton>
                      </span>
                    </h4>
                  </div>
                </div>
              </BCardBody>
            </BCard>
          </BCol>
          <BCol>
            <BCard no-body class="card-height-100">
              <BCardHeader class="border-0 align-items-center d-flex">
                <div class="flex-grow-1">
                  <BCardTitle class="mb-0">
                    {{ $t('dashboard.label.top_5') }}
                  </BCardTitle>
                  <small class="text-muted">
                    {{ $t('dashboard.label.sub_top_5') }}
                  </small>
                </div>
                <div>
                  <div class="flex-shrink-0 ms-2">
                    {{
                      new Intl.DateTimeFormat($i18n.locale, {
                        month: 'long',
                        year: 'numeric'
                      }).format(new Date())
                    }}
                  </div>
                </div>
              </BCardHeader>
              <loading :loading="$loading.get('dashboard_top_store')" variant="dark" type="block">
                <BCardBody>
                  <apexchart class="apex-charts" height="224" dir="ltr" :series="top_store.chart.series"
                    v-if="top_store.chart.series?.length"
                    :options="top_store.chart.chartOptions">
                  </apexchart>

                  <ul class="list-group list-group-flush border-dashed mb-0 mt-3 pt-2">
                    <li class="list-group-item px-0" v-for="(item, index) in top_store.table" :key="index">
                      <div class="d-flex">
                        <!-- <div class="flex-shrink-0 avatar-xs">
                        <span class="avatar-title bg-light p-1 rounded-circle shadow">
                          <img src="@/assets/images/svg/crypto-icons/btc.svg" class="img-fluid" alt="" />
                        </span>
                      </div> -->
                        <div class="flex-shrink-0 avatar-xs">
                          <div class="avatar-title rounded text-light rounded-circle shadow"
                            :style="{ background: item.color }">
                            <i class="mdi mdi-store-outline fs-4"></i>
                          </div>
                        </div>
                        <div class="flex-grow-1 ms-2">
                          <h6 class="mb-1">{{ item.name }}</h6>
                          <p class="fs-12 mb-0 text-muted">
                            {{ item.ref_no }}
                          </p>
                        </div>
                        <div class="flex-shrink-0 text-end">
                          <strong class="mb-1"><count-to :startVal='0' :endVal='item.total'
                              :duration='3000'></count-to></strong>
                        </div>
                      </div>
                    </li>
                  </ul>
                </BCardBody>
              </loading>
            </BCard>
          </BCol>
        </BRow>
      </BCol>
      <BCol lg="9">
        <BCard no-body>
          <BCardHeader class="border-0 align-items-center d-flex">
            <div class="flex-grow-1">
              <BCardTitle class="mb-0">
                {{ $t('dashboard.label.performance') }}
              </BCardTitle>
              <small class="text-muted">
                {{ $t('dashboard.label.sub_performance') }}
              </small>
            </div>
          </BCardHeader>
          <loading :loading="$loading.get('dashboard_performance')" variant="dark" type="block">
            <BCardBody class="p-0 pb-2">
              <div>
                <apexchart class="apex-charts" height="600" dir="ltr" :series="monthly.chart.series"
                  v-if="monthly.chart.series?.length"
                  :options="monthly.chart.chartOptions"></apexchart>
              </div>
            </BCardBody>
          </loading>
        </BCard>
      </BCol>
    </BRow>
  </Layout>
</template>